import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBJpOeufl_Qz49ZDQji6KjjEmVjChBp10M",
  authDomain: "e-school-dev.firebaseapp.com",
  projectId: "e-school-dev",
  storageBucket: "e-school-dev.firebasestorage.app",
  messagingSenderId: "971062771572",
  appId: "1:971062771572:web:27ef78e2ef01156075f621",
  measurementId: "G-F9DMX2J9ZG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);
const vapidKey = "BKTkPMxx10G3FrLz0mXIM2ROnI2O5S2mIGMnZy_Flv_3J5AEtG__QPjrUEGxzmWJg09BRJFuu4ASC7bpNC0NzAc";

// Request Notification Permission
async function requestNotificationPermission() {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: vapidKey
        });
      } else {
        console.error("Notification permission denied.");
      }
    } catch (error) {
      console.error("Error getting notification permission:", error);
    }
  }

export { app, db, messaging, vapidKey, getToken, onMessage, requestNotificationPermission };